<template>
	<div class="index">
		<div class="banner">
			<div class="videoBox">
				<video id = "video" controls="controls" style="width: 1200px;height: 560px;" playsinline="true" webkit-playsinline="true"  poster="../../assets/images/videoBg.png">
                      <source src="http://1255697701.vod2.myqcloud.com/cd014dcavodgzp1255697701/fd5309d15285890783138901951/WNNsgJyOfB4A.mp4" type="video/mp4"></source>
                      </video>
			</div>
		</div>
		<Panel title="互联网+养老" class="part1">
			<p class="wow slideInUp">
				2018年6月，民政部印发《“互联网+民政服务”行动计划》，重点提出要开展“互联网+养老服务”，推进智慧养老院示范创建，加快升级改造全国养老机构信息系统，积极引导、扶持和发展智慧养老。
			</p>
			<div class="slotContent">
				<div class="circle wow slideInLeft">
					<div class="wrap zero"><span></span></div>
					<div class="wrap one"><span></span></div>
					<div class="wrap two"><span></span></div>
					<div class="wrap three"><span></span></div>
					<div class="wrap four"><span></span></div>
				</div>
				<div class="news wow slideInRight">
					<ul>
						<li><span>2018年6月</span><i>民政部印发《“互联网+民政服务”行动计划》</i></li>
						<li><span>2018年6月</span><i>国务院办公厅印发《进一步深化“互联网+政府服务”推进政务改革实施方案》</i></li>
						<li><span>2017年10月</span><i>民政部关于统筹推进民政信息化建设的指导意见</i></li>
						<li><span>2016年9月</span><i>国务院关于加快推进“互联网+政务服务”工作的指导意见</i></li>
						<li><span>2015年7月</span><i>国务院关于积极推进“互联网+”行动的指导意见</i></li>
					</ul>
				</div>
			</div>
		</Panel>
		<Panel title="国外最佳实践" class="part2">
			<p class="wow slideInUp">
				“创新就是率先模仿”，充分学习欧美的最佳实践基础上，自2007年，泰康就开始了适合中国国情的把保险的虚拟产品和医养的实体服务结合起来的探索。
			</p>
			<div class="img wow slideInUp" style="padding: 7.5% 0 0;">
				<p style="color:#004325;font-size: 20px;height: 36px;">SENIOR HOUSING & CARE QUICK REFERENCE</p>
				<span style="display:block;color:#004325;font-size: 16px;height: 28px;">The chart below shows the characteristics of the housing types and care types we’ve outlined:</span>
				<img src="../../assets/images/guowai.png" alt="">
				<p style="display:block;color:#004325;font-size: 16px;margin-top: 20px;">*Home Health Companies may be available to contract these services on-site.</p>
			</div>
		</Panel>
		<Panel title="泰康养老模式" class="part1 part3">
			<div class="wrapper">
				<div class="item  wow slideInLeft">
					<div class="text">
						<img class="hexagon" src="../../assets/images/hexagon.png" alt="" />
						<!--<h4><i>4</i>位一体</h4>-->
						<h4>四位一体</h4>
						<p>“活力养老、高端医疗、卓越理财、终极关怀”四位一体的商业模式</p>
						<div style="text-align: right;">
							<img class="douhao" src="../../assets/images/douhao.png" alt="" />
						</div>
					</div>
					
				</div>
				<div class="item">
					<div class="imgs wow slideInRight">
						<div class="unit active"><img src="../../assets/images/icon_yangl.png" alt="" /><span>活力养老</span></div>
						<div class="unit"><img src="../../assets/images/icon_yiliao.png" alt="" /><span>高端医疗</span></div>
						<div class="unit"><img src="../../assets/images/icon_licai.png" alt="" /><span>卓越理财</span></div>
						<div class="unit"><img src="../../assets/images/icon_guanh.png" alt="" /><span>终极关怀</span></div>
					</div>	
				</div>
			</div>
		</Panel>
		<Panel title="" class="part3 part4">
			<div class="wrapper">
				<div class="item wow slideInLeft">
					<div class="imgs" style="width: 100%;">
						<img src="../../assets/images/twelve_cities.png" alt="" />
					</div>
				</div>
				<div class="item wow slideInRight">
					<div class="text" style="padding-left: 10%;">
						<img class="hexagon" src="../../assets/images/hexagon.png" alt="" />
						<!--<h4><i>12</i>城</h4>-->
						<h4>布局全国十二城</h4>
						<p>已经在全国布局十二城（北京、上海、广州、成都等已运营）高品质养老社区和康复医院。</p>
						<div style="text-align: right;">
							<img class="douhao" src="../../assets/images/douhao.png" alt="" />
						</div>
					</div>
				</div>
				
			</div>
		</Panel>
		<Panel title="" class="part3 part4">
			<div class="wrapper">
				<div class="item wow slideInLeft">
					<div class="text">
						<img class="hexagon" src="../../assets/images/hexagon.png" alt="" />
						<!--<h4><i>7</i>大核心需求</h4>-->
						<h4>七大核心需求</h4>
						<p>满足长辈“社交、运动、美食、文化、健康、财务管理和心灵的归属”七大核心需求</p>
						<div style="text-align: right;">
							<img class="douhao" src="../../assets/images/douhao.png" alt="" />
						</div>
					</div>
				</div>
				<div class="item imgs wow slideInRight" style="padding: 40px 0;text-align: left;justify-content:center;">
					<div class="circle">
						<div class="eleCon"><span></span></div>
						<div class="eleCon2"><span></span></div>
						<div class="eleCon3"><span></span></div>
						<div class="eleCon4"><span></span></div>
						<div class="eleCon5"><span></span></div>
						<div class="innerCircle">
							<div class="ieleCon"><span></span></div>
							<div class="ieleCon2"><span></span></div>
							<div class="ieleCon3"><span></span></div>
							<div class="inner">
								<div class="main">
									<img src="../../assets/images/icon_777.png" alt="" />
								</div>
							</div>
						</div>
					</div>
					<!--<img src="../../assets/images/xuqiu.png" alt="" />-->
				</div>
			</div>
		</Panel>
		<Panel title="" class="part3 part4">
			<div class="wrapper">
				<div class="item imgs wow slideInLeft" style="padding: 40px 0;">
					<div class="unit wow rollIn">
						<div class="icon">
							<span><img src="../../assets/images/icon_wenxin.png" alt="" /></span>
						</div>
						<p>温馨的家</p>
					</div>
					<div class="unit wow rollIn">
						<div class="icon">
							<span><img src="../../assets/images/icon_club.png" alt="" /></span>
						</div>
						<p>优雅的俱乐部</p>
					</div>
					<div class="unit wow rollIn">
						<div class="icon">
							<span><img src="../../assets/images/icon_daxue.png" alt="" /></span>
						</div>
						<p>开放的大学</p>
					</div>
					<div class="unit wow rollIn">
						<div class="icon">
							<span><img src="../../assets/images/icon_yiyang.png" alt="" /></span>
						</div>
						<p>高端的医养</p>
					</div>
					<div class="unit wow rollIn">
						<div class="icon">
							<span><img src="../../assets/images/icon_jiayuan.png" alt="" /></span>
						</div>
						<p>自主的精神家园</p>
					</div>
				</div>
				<div class="item wow slideInRight">
					<div class="text" style="padding-left: 10%;">
						<img class="hexagon" src="../../assets/images/hexagon.png" alt="" />
						<!--<h4><i>5</i>位一体</h4>-->
						<h4>五位一体</h4>
						<p>“温馨的家、高品质医疗保健中心、开放的大学、优雅的俱乐部、长辈心灵和精神的家园”五位一体的生活方式</p>
						<div style="text-align: right;">
							<img class="douhao" src="../../assets/images/douhao.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</Panel>
		<Panel title="自主知识产权" class="part2 part5">
			<p class="wow slideInUp">
				经过多年积累，泰养云已经申请了21项软件著作权，并有31项发明专利受理。2018年还承担了多项养老业务规范、信息标准的课题任务，希望通过搭建大健康产业生态体系，助力社会公益发展与养老产业变革。
			</p>
			<div class="img">
				<div class="item wow slideInLeft">
					<img src="../../assets/images/intel_property1.png" alt="">
				</div>
				<div class="item wow slideInRight">
					<img src="../../assets/images/intel_property2.png" alt="">
				</div>
			</div>
		</Panel>
		<Panel title="生态体系共赢" class="part6">
			<p class="wow slideInUp">
				泰康养老云平台不仅是泰康高品质养老产业的重要支撑，更是符合“互联网+养老服务”要求的优质解决方案，也具备“走出去”的实践经验。泰康愿意借助“溢彩公益计划”，在民政部门指导下，积极参与省级、地市级、区县级的区域智慧养老云平台建设，免费推广泰康养老云平台溢彩版，助力“互联网+养老服务”，赋能养老机构，深耕老年生命链，推动养老观念与生活方式创新、养老产业变革。
			</p>
			<div class="img wow slideInUp">
				<img src="../../assets/images/cooper.png" alt="">
			</div>
		</Panel>
		<Panel title="泰康养老云" class="part7">
			<p class="wow slideInUp">
				专注中国养老机构的数据服务平台
			</p>
		</Panel>
	</div>
</template>

<script>
	import ApiSetting from '../../assets/js/interface'
	import Panel from './panel.vue'
	export default {
		name: 'Home',
		props: [],
		data() {
			return {
			};
		},
		components: {
			Panel,
		},
		mounted() {
			//动画初使化
			new this.$WOW.WOW({live: false}).init();
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
@import '../../assets/css/common';
	@keyframes rotate{
		0%{transform: rotate(0deg);}
		50%{
			transform: rotate(180deg);
		}
		100%{
			transform: rotate(360deg);
		}
	}
	@keyframes rotate2{
		0%{transform: rotate(-30deg);}
		50%{
			transform: rotate(150deg);
		}
		100%{
			transform: rotate(330deg);
		}
	}
	@keyframes rotate3{
		0%{transform: rotate(30deg);}
		50%{
			transform: rotate(210deg);
		}
		100%{
			transform: rotate(390deg);
		}
	}
	@keyframes rotate4{
		0%{transform: rotate(-45deg);}
		50%{
			transform: rotate(135deg);
		}
		100%{
			transform: rotate(315deg);
		}
	}
	.part1{
		.panel();
		p{.text;}
		.slotContent{
			text-align:left;
			font-size:0;/*消除行内间距*/
			.circle{
				display:inline-block;
				/*background:pink;*/
				position: relative;
				width: 400px;
				left:-56px;
				height:400px;
				/*overflow: hidden;*/
				border-radius:0 50% 50% 0;
				border: 1px solid #ccc;
				&:before{
					content: '';
					position: absolute;
					width: 300px;
					height: 401px;
					top: -1px;
					left: -1px;
					border: 1px solid #fff;
					background: #fff;
				}
				.wrap{
					width:200px;
					height:10px;
					/*background:pink;*/
					position:absolute;
					top:50%;
					left:50%;
					margin-top:-5px;
					span{
						position: absolute;
						z-index:4;
						top:0;
						right: -5px;
						width: 10px;
						height: 10px;
						background: @backgroundColor;
						border-radius: 100%;
						box-shadow:0 0 0px 5px rgba(70,184,177,.2);
					}
					&.zero{
						span{
							animation:fade 4s infinite linear;
						};
					}	
					&.one{
						transform: rotate(-20deg);
						transform-origin:left center ;
						span{
							animation:fade 4s  1s infinite linear;
						};
					}	
					&.two{
						transform: rotate(-40deg);
						transform-origin:left center ;
						span{
							animation:fade 3s .2s infinite linear;
						};
					}	
					&.three{
						transform: rotate(20deg);
						transform-origin:left center ;
						span{
							animation:fade 3s .8s infinite linear;
						};
					}	
					&.four{
						transform: rotate(40deg);
						transform-origin:left center ;
						span{
							animation:fade 3s .4s infinite linear;
						};
					}		
				}
				@keyframes fade{
					0%{box-shadow:0 0 0px 5px rgba(70,184,177,.4);}
					50%{box-shadow:0 0 0px 5px rgba(70,184,177,0);}
					100%{box-shadow:0 0 0px 5px rgba(70,184,177,.4);}
				}
			}
			.news{
				display:inline-block;
				vertical-align: top;
				text-align: left;
				/*width:400px;*/
				height: 400px;
				margin-left: -32px;
    			margin-top: 38px;
    			ul{
    				float:left;
    				.wh100;
    				li{
    					box-sizing: border-box;
    					height: 76px;
    					/*line-height: 70px;*/
    					span{
    						color:@baseColor;
    						font-size: 20px;
    					}
    					i{
    						display: inline-block;
    						vertical-align: middle;
    						max-width: 423px;
    						word-break: break-all;
    						font-size: 16px;
    						line-height: 18px;
    						color: #666;
    						font-style: normal;
    						background: #f5f5f5;
    						padding:16px;
    						margin-left: 30px;
    					}
    					&:nth-child(1){
    						margin-left: -40px;
    						padding-top: 10px;
    					}
    					&:nth-child(2){
    						margin-left: -10px;
    						margin-top: -10px;
    					}
    					&:nth-child(4){
    						margin-left: -10px;
    						margin-top: -4px;
    					}
    					&:nth-child(5){
    						margin-left: -40px;
    						/*line-height: 60px;*/
    						margin-top: -15px;
    					}
    					
    				}
    			}
			}
		}
	}
	.part2{
		background: @backgroundColor;
		/deep/ .content h4{
			color: #fff;
		}
		p{
			.text;
			color: #fff;
		}
		.img{
			padding: 10% 0 0;
			img{
				cursor:pointer;
				transition-duration: 1s;
				&:hover{
					box-shadow:0 20px 50px rgba(0,0,0,.1);
				}
			}
		}
	}
	.part3{
		/deep/ .content{
			border-bottom: 1px solid #DDDDDD;
			padding: 105px 0;
		}
		.wrapper{
			display: flex;
			justify-content: space-around;
			.item{
				position: relative;
				flex: 1;
				text-align: center;
				.text{
					width: 60%;
					position: absolute;
					top: 50%;
					left: 20%;
					transform: translateY(-50%);
					padding:0 10% 0 14%;
					text-align: left;
					.hexagon{
						margin-left: -70px;
						animation: rotate 4s linear forwards infinite;
					}
					h4{
						font-family: 'Microsoft YaHei';
						font-size: 50px;
						color: #333;
						/*letter-spacing: 3px;*/
						height: 76px;
						margin: 0;
						/*i{
							color: @lightTextColor;
							font-size: 60px;
							font-family: Arial-BoldItalicMT;
						}*/
					}
				}
				.imgs{
					width: 60%;
					margin: 0 auto;
					font-size: 0;
					padding-top: 105px;
					.unit{
						vertical-align: top;
						display: inline-block;
						width: 130px;
						height: 110px;
						padding-top: 20px;
						text-align: center;
						background: @backgroundColor;
						border: 2px solid #40A6A0;
						margin: 6px;
						cursor: pointer;
						transform: scale(1);
						transition: transform 0.4s linear;
						&:nth-child(1){
							transform-origin:right bottom;
						}
						&:nth-child(2){
							transform-origin:left bottom;
						}
						&:nth-child(3){
							transform-origin:right top;
						}
						&:nth-child(4){
							transform-origin:left top;
						}
						&:nth-child(1),&:nth-child(4){
							border-radius:0 14px 0 14px;
						}
						&:nth-child(2),&:nth-child(3){
							border-radius:14px 0 14px 0;
						}
						&:hover,&.active{
							border: 2px solid #DF9129;
							background: @hoverBg;
							transform: scale(1.2);
							&:nth-child(1){
								transform-origin:right bottom;
							}
							&:nth-child(2){
								transform-origin:left bottom;
							}
							&:nth-child(3){
								transform-origin:right top;
							}
							&:nth-child(4){
								transform-origin:left top;
							}
							
						}
						span{
							font-size: 22px;
							margin-top: 10px;
							display: block;
							color: #fff;
						}
					}
				}
				
			}
		}
	}
	.part4{
		/deep/ .content{
			padding:50px 0;
		}
		/deep/ .content>h4{
			display: none;
		}
		.wrapper{
			.imgs{
				display: flex;
				flex-wrap: wrap;
				justify-content: flex-end;
				.unit{
					/*width: 126px;*/
					margin-bottom: 20px;
					.icon{
						/*box-sizing: border-box;*/
						width: 116px;
						height: 116px;
						border-radius: 50%;
						border: 5px dashed @hoverBg;
						text-align: center;
						margin:0 20px;
						span{
							display: inline-block;
							margin-top: 5px;
							width: 106px;
							height: 106px;
							border-radius: 50%;
							background: @hoverBg;
							transition: all 1s ease-in-out;
							&:hover{
								transform: rotateY(360deg);
							}
							img{
								margin-top: 20px;
							}
						}
					}
					p{
						font-size: 22px;
						margin-top: 8px;
						color: @hoverBg;
					}
					&:nth-child(4){
						margin-right:15px;
					}
					&:nth-child(5){
						margin-right:78px;
					}
					
				}
				.circle{
					position: relative;
					width: 450px;
					height: 450px;
					border-radius: 50%;
					border: 1px solid @backgroundColor;
					transition: all 2s linear;
					&:hover{
						.eleCon{
							animation: rotate2 30s linear infinite;
							transform-origin: center bottom;
						}
						.eleCon2{
							animation: rotate 30s linear infinite;
							transform-origin: right center;
						}
						.eleCon3{
							animation: rotate 30s linear infinite;
							transform-origin: center top;
						}
						.eleCon4{
							animation: rotate 30s linear infinite;
							transform-origin: left center;
						}
						.eleCon5{
							animation: rotate3 30s linear infinite;
							transform-origin: left center;
						}
						.ieleCon2{
							animation: rotate4 10s linear infinite;
							transform-origin: right center;
						}
						.ieleCon{
							animation: rotate 10s linear infinite;
							transform-origin: right center;
						}
						.ieleCon3{
							animation: rotate2 10s linear infinite;
							transform-origin: center top;
						}
					}
					.eleCon{
						position: absolute;
						top: 0;
						left: 50%;
						width: 70px;
						height: 50%;
						/*background: pink;*/
						margin-left: -35px;
						
						/*animation: rotate2 30s linear infinite;*/
						transform: rotate(-30deg);
						transform-origin: center bottom;
						span{
							transform: rotate(30deg);
							display: inline-block;
							background: @backgroundColor url(../../assets/images/icon_111.png) no-repeat center;
							width: 70px;
							height: 70px;
							border-radius: 50%;
							margin-top: -35px;
						}
					}
					.eleCon2{
						position: absolute;
						top: 50%;
						left: 0;
						width: 50%;
						height: 60px;
						/*background: pink;*/
						margin-top: -30px;
						text-align: left;
						/*animation: rotate 30s linear infinite;*/
						/*transform-origin: right center;*/
						span{
							display: inline-block;
							background: @hoverBg url(../../assets/images/icon_222.png) no-repeat center;
							width: 60px;
							height: 60px;
							border-radius: 50%;
							margin-left: -30px;
						}
					}
					.eleCon3{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 70px;
						height: 50%;
						/*background: pink;*/
						margin-left: -35px;
						/*animation: rotate 30s linear infinite;*/
						/*transform-origin: center top;*/
						span{
							display: inline-block;
							background: @backgroundColor url(../../assets/images/icon_444.png) no-repeat center;
							width: 70px;
							height: 70px;
							border-radius: 50%;
							position: absolute;
							left: 0;
							bottom: -35px;
						}
					}
					.eleCon4{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 50%;
						height: 60px;
						/*background: pink;*/
						margin-top: -30px;
						text-align: right;
						/*animation: rotate2 30s linear infinite;*/
						/*transform-origin: left center;*/
						span{
							display: inline-block;
							background: @hoverBg url(../../assets/images/icon_888.png) no-repeat center;
							width: 60px;
							height: 60px;
							border-radius: 50%;
							margin-right: -30px;
						}
					}
					.eleCon5{
						position: absolute;
						top: 50%;
						left: 50%;
						width: 50%;
						height: 50px;
						/*background: pink;*/
						margin-top: -25px;
						text-align: right;
						/*animation: rotate3 30s linear infinite;*/
						transform: rotate(30deg);
						transform-origin: left center;
						span{
							display: inline-block;
							background: @backgroundColor url(../../assets/images/icon_666.png) no-repeat center;
							transform: rotate(-30deg);
							width: 50px;
							height: 50px;
							border-radius: 50%;
							margin-right: -25px;
						}
					}
					.innerCircle{
						position: relative;
						margin-top: 95px;
						margin-left: 95px;
						width: 260px;
						height: 260px;
						border-radius: 50%;
						border: 1px dashed #b3b3b3;	
						&:before{
							position: absolute;
							content:'';
							width: 14px;
							height: 14px;
							border-radius: 50%;
							top:-40px;
							left: 40%;
							background: greenyellow;
							opacity: 0.4;
						}
						&:after{
							position: absolute;
							content:'';
							width: 26px;
							height: 26px;
							border-radius: 50%;
							top:-10px;
							right: -10px;
							background: blue;
							opacity: 0.3;
						}
						.ieleCon2{
							position: absolute;
							top: 50%;
							left: 0;
							width: 50%;
							height: 50px;
							/*background: pink;*/
							margin-top: -25px;
							text-align: left;
							/*animation: rotate2 10s linear infinite;*/
							transform: rotate(-45deg);
							transform-origin: right center;
							span{
								display: inline-block;
								background: @backgroundColor url(../../assets/images/icon_333.png) no-repeat center; ;
								transform: rotate(45deg);
								width: 50px;
								height: 50px;
								border-radius: 50%;
								margin-left: -25px;
							}
						}
						.ieleCon{
							position: absolute;
							top: 50%;
							left: 0;
							width: 50%;
							height: 24px;
							/*background: pink;*/
							margin-top: -12px;
							text-align: left;
							/*animation: rotate 10s linear infinite;*/
							/*transform-origin: right center;*/
							span{
								display: inline-block;
								background: @hoverBg ;
								width: 24px;
								height: 24px;
								border-radius: 50%;
								margin-left: -12px;
							}
						}
						.ieleCon3{
							position: absolute;
							top: 50%;
							left: 50%;
							width: 70px;
							height: 50%;
							/*background: pink;*/
							margin-left: -35px;
							/*animation: rotate2 10s linear infinite;*/
							transform: rotate(-30deg);
							transform-origin: center top;
							span{
								display: inline-block;
								background: @hoverBg url(../../assets/images/icon_555.png) no-repeat center;
								transform: rotate(30deg);
								width: 70px;
								height: 70px;
								border-radius: 50%;
								position: absolute;
								left: 0;
								bottom: -35px;
							}
						}
						.inner{
							position: relative;
							margin-top: 50px;
							margin-left: 50px;
							width: 160px;
							height: 160px;
							border-radius: 50%;
							border: 1px solid @backgroundColor;
							&:after{
								position: absolute;
								content:'';
								width: 14px;
								height: 14px;
								border-radius: 50%;
								top:40px;
								right: -20px;
								background: greenyellow;
								opacity: 0.4;
								
							}
							.main{
								position: relative;
								margin-top: 20px;
								margin-left: 20px;
								width: 120px;
								height: 120px;
								border-radius: 50%;
								background: @backgroundColor;
								text-align: center;
								cursor: pointer;
								&:hover{
									img{
										animation: doudong .4s linear;
									}	
								}
								img{
									margin-top: 35px;
									cursor: pointer;
									
								}
								@keyframes doudong{
									0%{transform: rotate(0deg);}
									25%{transform: rotate(-15deg);}
									75%{transform: rotate(15deg);}
									100%{transform: rotate(0deg);}
								}
							}
						}
					}
				}
			}
		}
		
	}
	.part5{
		/deep/ .content{
			padding: 105px 0;
		}
		p{
			padding:0 100px;
		}
		.img{
			display: flex;
			padding: 10% 0 0;
			.item{
				flex: 1;
				text-align: center;
				img{
					width: 70%;
					padding: 0;
					cursor:pointer;
					&:hover{
						box-shadow:0 0 0 @backgroundColor;
					}
				}
			}
		}
	}
	.part6{
		.panel();
		/deep/ .content{
			padding: 105px 100px 0;
		}
		p{.text;}
		.img{
			padding: 10% 0 0;
			img{
				vertical-align: top;/*解决三像素缝隙问题*/
			}
		}
	}
	.part7{
		.panel();
		background: url(../../assets/images/peoject.png) no-repeat center;
		background-size: cover;
		/deep/ .content>h4{
			color:#fff;
			font-size:50px ;
		}
		p{
			font-size: 36px;
			color: #fff;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/public/Home.vue